/* ============================================================
   Huellas del cliente para la oferta post-compra.

   Guarda dos listas y las escribe en los atributos del carrito,
   que es lo unico que viaja desde la tienda hasta el pedido y,
   de ahi, hasta nuestra app post-compra. El checkout esta aislado
   del escaparate: sin este puente, la app solo sabria que compro.

     _cs_fuera   prendas que metio en el carrito y luego saco
     _cs_vistos  fichas que miro y no compro

   Lo de "sacar del carrito" no se puede escuchar directamente: la
   peticion de cambio manda identificadores de linea, no handles. Se
   resuelve comparando el carrito antes y despues de cada cambio.
   ============================================================ */

(function () {
  if (window.__pp3Huellas) return;
  window.__pp3Huellas = true;

  var CARRITO = /\/cart\/(add|change|update|clear)/;
  var CLAVE_FUERA = 'cs_fuera';
  var CLAVE_VISTOS = 'cs_vistos';
  var CLAVE_CARRITO = 'cs_carrito';
  var MAXIMO = 6;

  var propio = false;      // evita reaccionar a nuestra propia escritura
  var ultimoEnviado = '';
  var temporizador = null;

  function leer(clave) {
    try {
      var v = JSON.parse(localStorage.getItem(clave));
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(clave, lista) {
    try { localStorage.setItem(clave, JSON.stringify(lista)); } catch (e) { /* sin almacenamiento */ }
  }

  function raiz() {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  }

  function traerCarrito() {
    return fetch(raiz() + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ---------- Que hay ahora mismo en el carrito ---------- */
  var enCarrito = [];

  function handlesDe(carrito) {
    if (!carrito || !carrito.items) return [];
    return carrito.items.map(function (i) { return i.handle; }).filter(Boolean);
  }

  /* ---------- Comparar antes y despues ---------- */
  function comparar(carrito) {
    var ahora = handlesDe(carrito);

    // Lo que estaba y ya no esta: se lo llevo a mirar y lo dejo fuera
    var fuera = leer(CLAVE_FUERA);
    enCarrito.forEach(function (h) {
      if (ahora.indexOf(h) === -1 && fuera.indexOf(h) === -1) fuera.unshift(h);
    });

    // Si lo ha vuelto a meter, deja de contar como abandonado
    fuera = fuera.filter(function (h) { return ahora.indexOf(h) === -1; }).slice(0, MAXIMO);

    guardar(CLAVE_FUERA, fuera);
    recordar(ahora);
    escribirAtributos(carrito, fuera);
  }

  // La foto del carrito se guarda en el navegador, no solo en memoria.
  // Sin esto, quitar algo desde la pagina del carrito -que recarga la
  // pagina entera- no se detectaba nunca: el "antes" moria con la
  // recarga y la comparacion se hacia contra una lista vacia.
  function recordar(lista) {
    enCarrito = lista;
    guardar(CLAVE_CARRITO, lista);
  }

  function revisar() {
    if (propio) return;
    return traerCarrito().then(function (carrito) {
      if (carrito) comparar(carrito);
    });
  }

  /* ---------- Escribir las listas en el carrito ---------- */
  function escribirAtributos(carrito, fuera) {
    // Con el carrito vacio no hay pedido que etiquetar
    if (!carrito || !carrito.items || !carrito.items.length) return;

    var dentro = handlesDe(carrito);
    // Lo que miro pero no se lleva puesto en el carrito
    var vistos = leer(CLAVE_VISTOS)
      .filter(function (h) { return dentro.indexOf(h) === -1 && fuera.indexOf(h) === -1; })
      .slice(0, MAXIMO);

    var valorFuera = fuera.join(',');
    var valorVistos = vistos.join(',');
    var firma = valorFuera + '|' + valorVistos;

    // Ya estan puestos: no hace falta otra peticion
    var att = carrito.attributes || {};
    if (att._cs_fuera === valorFuera && att._cs_vistos === valorVistos) {
      ultimoEnviado = firma;
      return;
    }
    if (firma === ultimoEnviado) return;
    ultimoEnviado = firma;

    propio = true;
    fetch(raiz() + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // El guion bajo delante es la convencion de Shopify para atributos
      // internos: no se ensenan al cliente en el proceso de compra.
      body: JSON.stringify({ attributes: { _cs_fuera: valorFuera, _cs_vistos: valorVistos } }),
    })
      .catch(function () { /* si falla, se reintenta en el proximo cambio */ })
      .then(function () { setTimeout(function () { propio = false; }, 300); });
  }

  function programar() {
    clearTimeout(temporizador);
    temporizador = setTimeout(revisar, 500);
  }

  /* ---------- Engancharse a los cambios del carrito ---------- */
  var fetchOriginal = window.fetch;
  if (fetchOriginal) {
    window.fetch = function (entrada, opciones) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var esCarrito = !propio && CARRITO.test(url);
      return fetchOriginal.apply(this, arguments).then(function (respuesta) {
        if (esCarrito) programar();
        return respuesta;
      });
    };
  }

  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__pp3Carrito = !propio && CARRITO.test(String(url || ''));
    return abrirOriginal.apply(this, arguments);
  };

  var enviarOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__pp3Carrito) this.addEventListener('load', programar);
    return enviarOriginal.apply(this, arguments);
  };

  /* ---------- Primera lectura ---------- */
  enCarrito = leer(CLAVE_CARRITO);
  traerCarrito().then(function (carrito) {
    if (!carrito) return;

    // Ojo con el carrito vacio al cargar: lo normal no es que lo haya
    // vaciado a mano, es que acaba de comprar -Shopify lo vacia al
    // cerrar el pedido-. Si se comparase, se apuntaria como abandonado
    // justo lo que acaba de pagar. Asi que se descarta la foto y ya.
    if (!carrito.items || !carrito.items.length) {
      recordar([]);
      return;
    }
    comparar(carrito);
  });
})();
